export default __webpack_public_path__ + "static/media/checkmark.b6eca70d.svg";